import React from "react";
import { Routes, Route } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import firebase from "firebase/compat/app";
import "firebase/compat/messaging";

import Menu from "../components/menu/Menu";
import Footer from "../components/common/Footer";
import Dashboard from "../components/dashboard/Dashboard";
import config from "../config/config";

import CustomerList from "../pages/CustomerList";
import CustomerUpdate from "../components/customer/CustomerUpdate";

import ModelAddUpdate from "../components/model/ModelAddUpdate";

import DuplicateLeadList from "../components/lead/DuplicateLeadList";
import LeadList from "../components/lead/LeadList";
import LeadPreview from "../components/lead/LeadPreview";
import LeadPrevNew from "../components/lead/LeadPreviewCompact";
import LeadHistory from "../components/lead/LeadHistory";
import LeadNextPrev from "../components/lead/LeadNextPrev";

import ContactList from "../pages/ContactList";
import ContactUpdate from "../components/contact/ContactUpdate";
import ContactPreview from "../components/contact/ContactPreview";

import CallList from "../pages/CallList";
import MeetingList from "../pages/MeetingList";
import NoteList from "../components/note/NoteList";
import ReportPreview from "../components/report/ReportPreview";
import ReportUpdateComplex from "../components/report/ReportUpdateComplex";
import ReportUpdate from "../components/report/ReportUpdate";
import PropertyList from "../components/property/PropertyList";
import PropertyUpdate from "../components/property/PropertyUpdate";
import PropertyPreview from "../components/property/PropertyPreview";

import ProjectList from "../components/project/ProjectList";
import ProjectUpdate from "../components/project/ProjectUpdate";
import ProjectPreview from "../components/project/ProjectPreview";

import TowerRoomUpdate from "../components/tower/TowerRoomUpdate";
import TowerPreview from "../components/tower/TowerPreview";

import AttendanceList from "../components/attendance/AttendanceList";
import AttendanceUpdate from "../components/attendance/AttendanceUpdate";

import AreaList from "../components/settings/AreaList";
import Settings from "../components/settings/Settings";

//import DashboardDemo from '../components/settings/dashboard/DashboardDemo';
//import DashboardPreview from '../components/settings/dashboard/DashboardPreview';
//import DashboardUpdate from '../components/settings/dashboard/DashboardUpdate';
import DashleadList from "../components/settings/dashboard/DashleadList";
import DashleadUpdate from "../components/settings/dashboard/DashleadUpdate";
import DashboardList from "../components/settings/dashboard/DashboardList";

import RoleUpdate from "../components/settings/user/RoleUpdate";
import RoleList from "../components/settings/user/RoleList";
import UserPreview from "../components/settings/user/UserPreview";
import UserMailUpdate from "../components/settings/user/UserMailUpdate";
import UserUpdate from "../components/settings/user/UserUpdate";
import UserList from "../components/settings/user/UserList";
import EmailConfig from "../components/settings/template/EmailConfig";
import EmailTemplateUpdate from "../components/settings/EmailTemplateUpdate";
import EmailTemplateList from "../components/settings/template/EmailTemplateList";
import EmailConfigurationUpdate from "../components/settings/EmailConfigurationUpdate";
import EmailConfigurationList from "../components/settings/EmailConfigurationList";

import SmsTemplateList from "../components/settings/template/SmsTemplateList";
import SmsConfigurationUpdate from "../components/settings/SmsConfigurationUpdate";
import SmsConfigurationList from "../components/settings/SmsConfigurationList";

import WhatsAppTemplateList from "../components/settings/template/WhatsAppTemplateList";
import CompanyPreview from "../components/settings/CompanyDetailsPreview";
import ConditionalField from "../components/settings/fields/conditional/ConditionalField";
import DocumentTypeList from "../components/settings/document-type/DocumentTypeList";
import OptionList from "../components/settings/fields/OptionList";
import ModuleList from "../components/settings/fields/ModuleList";
import FieldList from "../components/settings/fields/FieldList";
import CampaignList from "../components/campaign/CampaignList";
import ProductList from "../components/settings/product/ProductList";
import CategoryList from "../components/settings/product/ProductCategoryList";
import UnitMeasureList from "../components/settings/product/ProductUnitMeasureList";
import ProductImport from "../components/settings/product/ProductImport";
import ProbabilityList from "../components/settings/ProbabilityList";
import InsallmentModeList from "../components/settings/InsallmentModeList";
import SourceList from "../components/settings/SourceList";
import SalesOrderList from "../components/sales_order/SalesOrderList";
import SalesOrderPreview from "../components/sales_order/SalesOrderPreview";
import SalesOrderUpdate from "../components/sales_order/SalesOrderUpdate";
import InstallmentList from "../pages/InstallmentList";
import SmsList from "../components/settings/SmsList";
import SmsAdd from "../components/settings/SmsAdd";
import DistributeList from "../components/settings/automation/LeadDistributionList";
import DistributeUpdate from "../components/settings/automation/LeadDistributionUpdate";
import AutomationList from "../components/settings/automation/AutomationList";
import AutomationUpdate from "../components/settings/automation/AutomationUpdate";
import AutomationPreview from "../components/settings/automation/AutomationPreview";
import AutoReportList from "../components/settings/automation/AutoReportList";
import CustomReminderList from "../components/settings/custom-reminder/CustomReminderList";
import CustomReminderUpdate from "../components/settings/custom-reminder/CustomReminderUpdate";
import BigCalendar from "../components/calendar/BigCalendar";
import SearchTable from "../components/list/SearchTable";
import ImportList from "../components/settings/import-export/ImportList";
import ExportList from "../components/settings/import-export/ExportList";
import ImportDetails from "../components/settings/import-export/ImportDetails";
import LeadDistributionPreview from "../components/settings/automation/LeadDistributionPreview";
import MassMailList from "../components/settings/marketing/MassMailList";
import MassMailPrev from "../components/settings/marketing/MassMailPrev";
import MassSmsList from "../components/settings/marketing/MassSmsList";
import MassSmsPrev from "../components/settings/marketing/MassSmsPrev";
import MassWhatsAppList from "../components/settings/marketing/MassWhatsAppList";
import MassWhatsAppPrev from "../components/settings/marketing/MassWhatsAppPrev";
import ViewList from "../components/settings/view/ViewList";
import ViewUpdate from "../components/settings/view/ViewUpdate";
import ActionList from "../components/settings/custom-action/ActionList";
import ActionUpdate from "../components/settings/custom-action/ActionUpdate";
import ActionPreview from "../components/settings/custom-action/AutomationPreview";

import ThirdPartyRoute from "../route/ThirdPartyRoute";

import BillingList from "../components/settings/billing/BillingList";

import PropertyProjectTemplateList from "../components/settings/template/PropertyProjectTemplateList";
import PropertyProjectTemplateUpdate from "../components/settings/template/PropertyProjectTemplateUpdate";

import Const from "../util/Constants";
import ApiUiController from "./ApiUiController";
import LoginAPI from "../api/LoginAPI";
import ModelAPI from "../api/ModelAPI";
import KeyValueAPI from "../api/KeyValueAPI";
import ActionAPI from "../api/ActionAPI";
import ViewAPI from "../api/ViewAPI";
import ConditionalFieldAPI from "../api/ConditionalFieldAPI";
import KanbanAPI from "../api/KanbanAPI";
import LeadImport from "../components/lead/LeadImport";

import Themes from "../util/Themes";
import withRouter from "../util/WithRouter";
import ModuleFieldList from "../components/settings/fields/ModuleFieldList";
import Notifications from "../pages/Notifications";
import CustomerPreview from "../components/customer/CustomerPreview";
import AreaAPI from "../api/AreaAPI";
import ThirdPartyAPI from "../api/ThirdPartyAPI";
import TowerAPI from "../api/TowerAPI";
import RoomAPI from "../api/RoomAPI";
import Util from "../util/Util";
import DefaultControllerConst from "../util/DefaultControllerConst";
import Display from "../util/Display";

import LeadConst from "../util/LeadConst";
import PropertyConst from "../util/PropertyConst";
import ProjectConst from "../util/ProjectConst";
import ApiLogList from "../components/settings/third-party/ApiLogList";
import ReportList2 from "../components/report/ReportList2";
import DailySalesReport from "../components/report/DailySalesReport/DailySalesReport";
import IndividualSalesReport from "../components/report/IndividualPerformanceReport/IndividualSalesReport";
import DailySalesReportPage from "../components/report/DailySalesReport/DailySalesReportPage";
import IndividualSalesReportPage from "../components/report/IndividualPerformanceReport/IndividualSalesReportPage";
import LeadScoreAddUpdate from "../components/settings/automation/LeadScoreUpdate";
import LeadScoreList from "../components/settings/automation/LeadScoreList";
import LeadScorePreview from "../components/settings/automation/LeadScorePreview";
import FixedCallReport from "../components/report/FixedCallReport";
import FixedMeetingReport from "../components/report/FixedMeetingReport";
import FixedSalesOrderReport from "../components/report/FixedSalesOrder";
import LeadBySourceReport from "../components/report/leadFixedReports/LeadBySource";
import LeadByStatusReport from "../components/report/leadFixedReports/LeadByStatus";
import LeadByProjectReport from "../components/report/leadFixedReports/LeadByProject";
import LeadBySalesPerson from "../components/report/leadFixedReports/LeadBySalesExecitive";
import LeadByConversionBySalesPerson from "../components/report/leadFixedReports/LeadConversionBySalesExecutive";
import LeadConversionBySource from "../components/report/leadFixedReports/LeadByConversionBySource";
import LeadBySourceBySalesPerson from "../components/report/leadFixedReports/LeadBySourceBySalesPerson";
import LeadUntouchedBySalesExecutive from "../components/report/leadFixedReports/LeadUntouchedBySalesExecutive";
import CallTalktimeFixedReport from "../components/report/callFixedReports/CallTalktimeReports";
import CallBySourceBySalesPerson from "../components/report/callFixedReports/CallFeedbackBySalesExecutive";
import CompletedCallReport from "../components/report/callFixedReports/CompletedCallsReport";
import PendingCallReport from "../components/report/callFixedReports/PendingCallsReport";
import CallCountBySalesPerson from "../components/report/callFixedReports/CallCountReports";
import MissedCallReport from "../components/report/callFixedReports/MissedCallReports";
import MonthlySiteVisitReport from "../components/report/siteVisitFixedReports/MonthlySiteVisitReport";
import SiteVisitBySalesPerson from "../components/report/siteVisitFixedReports/SiteVisitBySalesExecutive";
import SiteVisitByFeedbackBySalesPerson from "../components/report/siteVisitFixedReports/SiteVisitfeedbackBySalesExecutive";
import ConsolidatedActivityReport from "../components/report/consolidatedFixedReport/consolidatedActivityReport";
import BookingBySalesPerson from "../components/report/bookingFixedReport/BookingBySalesExecutiveReport";
import BookingByProjectReport from "../components/report/bookingFixedReport/BookingbyProjectsReport";
import MonthlyBookingReport from "../components/report/bookingFixedReport/MonthlyBookingReport";
import ProjectBySalesReport from "../components/report/revenueReport/ProjectBysale";
import RevenueBySalesExecutive from "../components/report/revenueReport/RevenueBySaleExecutive";
import BookingBySource from "../components/report/bookingFixedReport/BookingBySource";
import BookingBySourceByProject from "../components/report/bookingFixedReport/BookingBySourceBySalesExecutive";
import MonthlyBookingBySalesExecutiveReport from "../components/report/bookingFixedReport/MonthlyBookingBySalesExecutiveReport";
import LeadByTypeBySalesPerson from "../components/report/leadFixedReports/LeadsByTypeBySalesExecutive";
import MonthlyLeadsBySourceReport from "../components/report/leadFixedReports/MonthlyLeadsBySourceReport";
import MonthlyLeadsBySalesExecutiveReport from "../components/report/leadFixedReports/MonthlyLeadsBysalesExecutive";
import MonthlySiteVisitByFeedbackReport from "../components/report/siteVisitFixedReports/MonthlySiteVisitBySource";
import MonthlySiteVisitBySalesExecutiveReport from "../components/report/siteVisitFixedReports/MonthlySiteVisitBySalesExecutiveReport";
import MonthlyAttendanceBySalesPersonReport from "../components/report/attendanceReport/MonthlyAttendanceBySalesPersonReport";
import MonthlySiteVisitBySourceReport from "../components/report/siteVisitFixedReports/MonthlySiteVisitByLeadSourceReport";
import FixedLeadReport from "../components/report/FixedLeadReport";
import LeadcallFeedbackBySalesperson from "../components/report/callFixedReports/LeadCallFeedbackBySalesPerson";
import LeadcallFeedbackByProject from "../components/report/callFixedReports/LeadCallFeedbackByProject";
import LeadToSiteVisitRatioSalesExecutiveWise from "../components/report/consolidatedFixedReport/LeadToSiteVisitRatioSalesExecutiveWise";
import LeadToSiteVisitRatioMonthWise from "../components/report/consolidatedFixedReport/LeadToSiteVisitRatioMonthWise";

import ColdDataImport from "../components/cold_data/ColdDataImport";
import ColdDataList from "../components/cold_data/ColdDataList";
import ColdDataPreview from "../components/cold_data/ColdDataPreview";
import ColdDataDataPreview from "../components/cold_data/ColdDataDataPreview";
import CallStatusReport from "../components/report/callFixedReports/CallStatusReport";
import HourlyCallReport from "../components/report/callFixedReports/HourlyCallReport";
import DailyAttendanceBySalesPersonReport from "../components/report/attendanceReport/DailyAttendanceBySalesPersonReport";
import BookingPreviewWrapper from "../components/sales_order/BookingPreviewWrapper";
import AiIntegrationList from "../components/settings/third-party/AiIntegrationList";
import AddAiIntegration from "../components/settings/third-party/AddAiIntegration";
import LocationTracker from "../components/live_location_tracking/LiveLocationList";
import FloorRisePreview from "../components/floor_rise/FloorRisePreview";
import LeadPrevDesign4 from "../components/lead/LeadPrevDesign4";
import LeadStatusBySalesPerson from "../components/report/leadFixedReports/LeadStatusBySalesPerson";
import CallFeedbackBySalespersonWithLead from "../components/report/callFixedReports/CallFeedbackBySalespersonWithLead";
import KanbanList from "../components/settings/kanban/KanbanList";
import KanbanUpdate from "../components/settings/kanban/KanbanUpdate";
import FacebookCallback from "../components/settings/third-party/FacebookCallback";
import SalesExecutivePerformanceReport2 from "../components/report/SalesExecutivePerformanceReport2";

class DefaultController extends React.Component {
  constructor(props) {
    super(props);
    this.loggedIn = reactLocalStorage.get(Const.LoggedIn) === Const.STrue;
    this.state = { inApiCall: this.loggedIn, isModuleChanged: false };
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.isGrowthPackageAndAbove = this.user?.package >= Const.PackageGrowth;
  }

  onFail = () => this.setState({ ...this.state, inApiCall: false });

  componentDidMount() {
    if (this.loggedIn) {
      const auth = reactLocalStorage.get(Const.Token);
      LoginAPI.auth(auth, this.onAuthResponse, this.onFail, this.onLogout);
    } else {
      window.location.href = config.auth + "logout";
    }
  }

  onAuthResponse = (response) => {
    reactLocalStorage.set(Const.LoggedIn, Const.STrue);
    reactLocalStorage.set(Const.Token, response.auth);
    reactLocalStorage.set(Const.System, response.system);
    let code = response.user.default_code;
    response.user.default_code = code !== undefined ? code : "+91";
    reactLocalStorage.setObject(Const.LoggedInUser, response.user);
    ModelAPI.getModel(this.onModel, this.onFail);
  };

  onModuleChanged = () => {
    this.setState({ ...this.state, inApiCall: true, isModuleChanged: true });
    ModelAPI.getModel(this.onModel, this.onFail);
  };

  onModel = (model) => {
    //Apply Role permission to main fields
    const RoleFields = model.role.options.find(
      (option) => option.value === this.user.role
    ).permission;
    for (let i = 0; i < RoleFields.length; i++) {
      const modelKeys = Object.keys(model);
      const modelName = modelKeys.find(
        (key) => model[key].model_no === RoleFields[i].model_no
      );
      if (modelName) {
        const fieldKeys = Object.keys(model[modelName].fields);
        const fieldName = fieldKeys.find(
          (key) => model[modelName].fields[key].id === RoleFields[i].field_id
        );
        if (fieldName) {
          const field = model[modelName].fields[fieldName];
          field.visible = RoleFields[i].visible;
          field.editable = RoleFields[i].editable;
          field.form_mandate = RoleFields[i].form_mandate;
        }
      }
    }
    reactLocalStorage.setObject(Const.Model, model);
    ModelAPI.getCountries(this.onCountry, this.onFail);
  };

  onCountry = (res) => {
    reactLocalStorage.setObject(Const.Countries, res);
    ModelAPI.getStates(this.onState, this.onFail);
  };

  onState = (res) => {
    reactLocalStorage.setObject(Const.States, res);
    ModelAPI.getCities(this.onCity, this.onFail);
  };

  onCity = (res) => {
    reactLocalStorage.setObject(Const.Cities, res);
    AreaAPI.list(this.onArea, this.onFail);
  };

  onArea = (res) => {
    reactLocalStorage.setObject(Const.Areas, res);
    ActionAPI.list(this.onAction, this.onFail);
  };

  onAction = (actions) => {
    actions = actions.map((action) => {
      action.conditions = JSON.parse(action.conditions);
      return action;
    });
    reactLocalStorage.setObject(Const.Actions, actions);
    ViewAPI.list(this.onView, this.onFail);
  };

  onView = (res) => {
    res = res.map((item) => {
      return {
        ...item,
        filters: JSON.parse(item.filters),
        fields: JSON.parse(item.fields),
      };
    });
    reactLocalStorage.setObject(Const.Views, res);
    KanbanAPI.list(this.onKanbanViews, this.onFail);
  };

  onKanbanViews = (res) => {
    reactLocalStorage.setObject(Const.KanbanViews, res);
    ConditionalFieldAPI.list(this.onConditionalField, this.onFail);
  }

  onConditionalField = (fields) => {
    const models = reactLocalStorage.getObject(Const.Model);
    const modelKeys = Object.keys(models);
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      let j = 0;
      for (; j < modelKeys.length; j++) {
        if (models[modelKeys[j]].model_no === field.model) {
          break;
        }
      }
      if (j < modelKeys.length) {
        const model = models[modelKeys[j]];
        const fieldKeys = Object.keys(model.fields);
        let k = 0;
        for (; k < fieldKeys.length; k++) {
          if (model.fields[fieldKeys[k]].id === field.field_id) {
            model.fields[fieldKeys[k]].conditional_field =
              field.conditional_field;
            break;
          }
        }
      }
    }
    reactLocalStorage.setObject(Const.Model, models);

    const key = `${Const.FieldList}-${this.user.user_id}`;
    const keys = [
      key,
      ProjectConst.Inventory,
      LeadConst.SearchLead,
      PropertyConst.SearchProperty,
      PropertyConst.FieldLevelSecurity,
    ];
    KeyValueAPI.list(keys, this.onKeys, this.onFail);
  };

  onKeys = async (items) => {
    const inventory =
      items && items.find((item) => item.field_key === ProjectConst.Inventory);
    const IsInventory = inventory
      ? inventory.field_value === Const.TextTrue
      : false;
    reactLocalStorage.set(Const.ProjectInventory, IsInventory);

    const info =
      items &&
      items.find((item) => item.field_key === PropertyConst.FieldLevelSecurity);
    const FieldLevelSecurity = info
      ? info.field_value === Const.TextTrue
      : false;
    reactLocalStorage.set(PropertyConst.FieldLevelSecurity, FieldLevelSecurity);

    const key = `${Const.FieldList}-${this.user.user_id}`;
    const fields = items && items.find((item) => item.field_key === key);
    if (fields) {
      try {
        const value = JSON.parse(fields.field_value);
        const keys = Object.keys(value);
        for (let i = 0; i < keys.length; i++) {
          if (
            value[keys[i]] &&
            typeof value[keys[i]] === "object" &&
            typeof value[keys[i]][0] === "object"
          ) {
            value[keys[i]] = value[keys[i]].map((view) => {
              return { ...view, filters: [] };
            });
          }
        }
        reactLocalStorage.setObject(Const.FieldList, value);
      } catch (err) { }
    }

    let SearchLead = items
      ? items.find((item) => item.field_key === LeadConst.SearchLead)
      : null;
    SearchLead = SearchLead
      ? JSON.parse(SearchLead.field_value)
      : [
        LeadConst.MinBudget,
        LeadConst.PropertyTransaction,
        LeadConst.PropertyType,
        LeadConst.PropertyIs,
      ];
    reactLocalStorage.setObject(LeadConst.SearchLead, SearchLead);

    let SearchProperty = items
      ? items.find((item) => item.field_key === PropertyConst.SearchProperty)
      : null;
    SearchProperty = SearchProperty
      ? JSON.parse(SearchProperty.field_value)
      : [
        PropertyConst.Price,
        PropertyConst.PropertyTransaction,
        PropertyConst.PropertyType,
        PropertyConst.Type,
        PropertyConst.TransactionType,
      ];
    reactLocalStorage.setObject(PropertyConst.SearchProperty, SearchProperty);

    if (!IsInventory) {
      ThirdPartyAPI.cloud(this.onTeleCalling, this.onFail);
    } else {
      TowerAPI.options(this.onTower, this.onFail);
    }
  };

  onTower = (res) => {
    reactLocalStorage.setObject(Const.Towers, res);
    RoomAPI.options(this.onRoom, this.onFail);
  };

  onRoom = (res) => {
    reactLocalStorage.setObject(Const.Rooms, res);
    ThirdPartyAPI.cloud(this.onTeleCalling, this.onFail);
  };

  onTeleCalling = async (res) => {
    let api = null;
    for (let i = 0; res && i < res.length; i++) {
      const apis = JSON.parse(res[i].api_data);
      if (apis) {
        const user = this.user.user_id;
        api = apis.find((api) => api.user === user);
        if (api) {
          api.party_type = res[i].party_type;
          api.access_token = res[i].access_token;
        }
      }
    }

    if (api) {
      reactLocalStorage.setObject(Const.CloudCalling, api);
    } else {
      reactLocalStorage.remove(Const.CloudCalling);
    }

    try {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          firebase
            .messaging()
            .getToken()
            .then((token) => {
              if (token) {
                LoginAPI.regToken(token, () => { });
                firebase
                  .messaging()
                  .onMessage((payload) => this.onNotification(payload));
              }
            });
        } else {
          Util.showNotification(
            "Notification",
            "Please Allow notification",
            "danger"
          );
        }
      });
    } catch (err) {
      console.log(err);
    }

    if (!this.state.isModuleChanged) {
      this.setState({ ...this.state, inApiCall: false });
    } else {
      this.setState({
        ...this.state,
        inApiCall: false,
        isModuleChanged: false,
      });
    }
  };

  onNotification = (payload) => {
    var body = null;
    try {
      body = JSON.parse(payload.data.data);
    } catch (err) {
      console.log(err);
    }

    if (body) {
      const NOTIFY_REMINDER = 1;
      const NOTIFY_ASSIGN = 2;
      const NOTIFY_RE_ASSIGN = 3;
      const NOTIFY_WORK_DONE = 4;
      const NOTIFY_LEAD_CREATEDBY_WEBHOOK = 5;

      const models = reactLocalStorage.getObject(Const.Model);

      const name = Display.ModelName(body.data);
      var title = "";
      var action = "";
      if (body.model === 1) {
        title = models.lead.model_name;
        action = `/lead/preview/${body.data.id}`;
      } else if (body.model === 2) {
        title = models.contact.model_name;
        action = `/contact/preview/${body.data.id}`;
      } else if (body.model === 3) {
        title = models.sales_order.model_name;
        action = `/sales-order/preview/${body.data.id}`;
      } else if (body.model === 4) {
        title = models.customer.model_name;
        action = `/customer/preview/${body.data.id}`;
      } else if (body.model === 5) {
        title = models.call.model_name;
        if (body.data.model_no === 1) {
          action = `/lead/preview/${body.data.model_id}`;
        } else if (body.data.model_no === 2) {
          action = `/contact/preview/${body.data.model_id}`;
        }
      } else if (body.model === 6) {
        title = models.meeting.model_name;
        if (body.data.model_no === 1) {
          action = `/lead/preview/${body.data.model_id}`;
        } else if (body.data.model_no === 2) {
          action = `/contact/preview/${body.data.model_id}`;
        }
      }

      let stick = false;
      if (body.type === NOTIFY_REMINDER) {
        title = `${title}: ${name}\n Reminder`;
        stick = true;
      } else if (body.type === NOTIFY_ASSIGN) {
        title = `${title}: ${name}\n Assigned`;
      } else if (body.type === NOTIFY_RE_ASSIGN) {
        title = `${title}: ${name}\n Re-Assigned`;
      } else if (body.type === NOTIFY_WORK_DONE) {
        title = `${title}: ${name}\n Completed`;
      } else if (body.type === NOTIFY_LEAD_CREATEDBY_WEBHOOK) {
        title = `New lead has been assigned: ${name}`;
        stick = true;
      }
      Util.showNotification(
        "Notification",
        title,
        "success",
        () => this.props.navigate(action),
        stick
      );
    }
  };

  render() {
    const isLoggedIn = reactLocalStorage.get(Const.LoggedIn) === Const.STrue;
    if (!isLoggedIn) {
      this.props.navigate("/");
      return null;
    }

    let theme = this.user.theme;
    theme = Themes.find((Theme) => Theme.value === theme);
    const LeadTheme = reactLocalStorage.get(Const.LeadTheme)
      ? parseInt(reactLocalStorage.get(Const.LeadTheme))
      : reactLocalStorage.set(Const.LeadTheme, 3);

    const param = { onModuleChanged: this.onModuleChanged };
    return (
      <div className={`header-bg-${theme ? theme.name : "purple"}`}>
        <ApiUiController inApiCall={this.state.inApiCall}>
          <Menu moduleChanged={this.state.isModuleChanged} />
          <Routes>
          <Route
            path="/facebook-callback"
            element={<FacebookCallback {...param} />}
          />
            <Route
              path="/cold-data/add"
              element={<ColdDataImport {...param} />}
            />
            <Route
              path="/cold-data/campaign/:id"
              element={<ColdDataPreview {...param} />}
            />
            <Route
              path="/cold-data/campaign/data/:id"
              element={<ColdDataDataPreview {...param} />}
            />
            <Route path="/cold-data" element={<ColdDataList />} {...param} />

            <Route
              path="/report/add-edit/:id"
              element={<ReportUpdateComplex />}
              {...param}
            />
            {/* <Route path='/report/add-edit/:id' element={<ReportUpdate {...param} />} /> */}
            <Route
              path="/report/:reportId"
              element={<ReportPreview {...param} />}
            />
            {/* <Route path='/report' element={<ReportList />} {...param} /> */}
            <Route path="/report" element={<ReportList2 />} {...param} />
            <Route
              path="/report/dailySalesReport"
              element={<DailySalesReport {...param} />}
            />
            <Route
              path="/report/individualSalesReport"
              element={<IndividualSalesReport {...param} />}
            />
            <Route
              path="/report/dailySalesReport/1"
              element={<DailySalesReportPage {...param} />}
            />
            <Route
              path="/report/individualSalesReport/1"
              element={<IndividualSalesReportPage {...param} />}
            />
            <Route
              path="/report/leadReport"
              element={<FixedLeadReport {...param} />}
            />
            <Route
              path="/report/callReport"
              element={<FixedCallReport {...param} />}
            />
            <Route
              path="/report/siteVisitReport"
              element={<FixedMeetingReport {...param} />}
            />
            <Route
              path="/report/SalesOrderReport"
              element={<FixedSalesOrderReport {...param} />}
            />

            {/* fixed reports */}
            <Route
              path="/report/LeadBySourceReport"
              element={<LeadBySourceReport {...param} />}
            />
            <Route
              path="/report/LeadByStatusReport"
              element={<LeadByStatusReport {...param} />}
            />
            <Route
              path="/report/LeadByProjectReport"
              element={<LeadByProjectReport {...param} />}
            />
            <Route
              path="/report/leadBySalesPerson"
              element={<LeadBySalesPerson {...param} />}
            />
            <Route
              path="/report/LeadBySalesExecutiveReport"
              element={<LeadByConversionBySalesPerson {...param} />}
            />
            <Route
              path="/report/LeadConversionBySource"
              element={<LeadConversionBySource {...param} />}
            />
            <Route
              path="/report/leadBySourceBySalesPerson"
              element={<LeadBySourceBySalesPerson {...param} />}
            />
            <Route
              path="/report/leadStatusBySalesPerson"
              element={<LeadStatusBySalesPerson {...param} />}
            />
            <Route
              path="/report/leadsUntouchedBySalesExecutive"
              element={<LeadUntouchedBySalesExecutive {...param} />}
            />
            <Route
              path="/report/LeadByTypeBySalesPerson"
              element={<LeadByTypeBySalesPerson {...param} />}
            />
            <Route
              path="/report/monthlyLeadsBySourceReport"
              element={<MonthlyLeadsBySourceReport {...param} />}
            />
            <Route
              path="/report/monthlyLeadsBySalesExecutiveReport"
              element={<MonthlyLeadsBySalesExecutiveReport {...param} />}
            />

            {/* fixed Call reports */}
            <Route
              path="/report/callTalkTimeReport"
              element={<CallTalktimeFixedReport {...param} />}
            />
            <Route
              path="/report/callFeedbackBySalesperson"
              element={<CallBySourceBySalesPerson {...param} />}
            />
            <Route
              path="/report/callFeedbackBySalespersonwithLead"
              element={<CallFeedbackBySalespersonWithLead {...param} />}
            />
            <Route
              path="/report/leadcallFeedbackBySalesperson"
              element={<LeadcallFeedbackBySalesperson {...param} />}
            />
            <Route
              path="/report/leadcallFeedbackByProject"
              element={<LeadcallFeedbackByProject {...param} />}
            />
            <Route
              path="/report/callCompleteReport"
              element={<CompletedCallReport {...param} />}
            />
            <Route
              path="/report/callPendingReport"
              element={<PendingCallReport {...param} />}
            />
            <Route
              path="/report/callCountReport"
              element={<CallCountBySalesPerson {...param} />}
            />
            <Route
              path="/report/missedCallReport"
              element={<MissedCallReport {...param} />}
            />
            <Route
              path="/report/callStatusReport"
              element={<CallStatusReport {...param} />}
            />
            <Route
              path="/report/callStatusByHourReport"
              element={<HourlyCallReport {...param} />}
            />

            {/* fixed meeting report */}
            <Route
              path="/report/monthlySiteVisitReport"
              element={<MonthlySiteVisitReport {...param} />}
            />
            <Route
              path="/report/monthlySiteVisitByFeedbackReport"
              element={<MonthlySiteVisitByFeedbackReport {...param} />}
            />
            <Route
              path="/report/monthlySiteVisitBySalesExecutiveReport"
              element={<MonthlySiteVisitBySalesExecutiveReport {...param} />}
            />
            <Route
              path="/report/MonthlySiteVisitBySourceReport"
              element={<MonthlySiteVisitBySourceReport {...param} />}
            />
            <Route
              path="/report/siteVisitBySalesExecutiveReport"
              element={<SiteVisitBySalesPerson {...param} />}
            />

            <Route
              path="/report/siteVisitFeedbackBySalesPerson"
              element={<SiteVisitByFeedbackBySalesPerson {...param} />}
            />

            <Route
              path="/report/salesExecutivePerformanceReport2"
              element={<SalesExecutivePerformanceReport2 {...param} />}
            />

            {/* consolidated report */}
            <Route
              path="/report/consolidatedActivityReport"
              element={<ConsolidatedActivityReport {...param} />}
            />
            <Route
              path="/report/leadToSiteVisitRatioMonthWise"
              element={<LeadToSiteVisitRatioMonthWise {...param} />}
            />
            <Route
              path="/report/leadToSiteVisitRatioSalesExecutiveWise"
              element={<LeadToSiteVisitRatioSalesExecutiveWise {...param} />}
            />

            {/* Attendance Report */}
            <Route
              path="/report/monthlyAttendanceBySalesPersonReport"
              element={<MonthlyAttendanceBySalesPersonReport {...param} />}
            />

            <Route
              path="/report/DailyAttendanceBySalesPersonReport"
              element={<DailyAttendanceBySalesPersonReport {...param} />}
            />

            {/* sales order report  */}
            <Route
              path="/report/bookingBySalesExecutive"
              element={<BookingBySalesPerson {...param} />}
            />
            <Route
              path="/report/bookingByProject"
              element={<BookingByProjectReport {...param} />}
            />
            <Route
              path="/report/monthlySalesReport"
              element={<MonthlyBookingReport {...param} />}
            />
            <Route
              path="/report/projectBySales"
              element={<ProjectBySalesReport {...param} />}
            />
            <Route
              path="/report/revenueBySalesExecutive"
              element={<RevenueBySalesExecutive {...param} />}
            />
            <Route
              path="/report/bookingBySource"
              element={<BookingBySource {...param} />}
            />
            <Route
              path="/report/bookingBySourceByProject"
              element={<BookingBySourceByProject {...param} />}
            />
            <Route
              path="/report/monthlySalesReportbySalesExecutive"
              element={<MonthlyBookingBySalesExecutiveReport {...param} />}
            />
            <Route
              path="/setting/company-preview"
              element={<CompanyPreview {...param} />}
            />
            <Route
              path="/setting/action/preview/:id"
              element={<ActionPreview {...param} />}
            />
            <Route
              path="/setting/action/:id"
              element={<ActionUpdate {...param} />}
            />
            <Route path="/setting/action" element={<ActionList {...param} />} />

            <Route
              path="/setting/distribution/preview/:id"
              element={<LeadDistributionPreview {...param} />}
            />
            <Route
              path="/setting/distribution/:id"
              element={<DistributeUpdate {...param} />}
            />
            <Route
              path="/setting/distribution"
              element={<DistributeList {...param} />}
            />

            <Route
              path="/setting/automation/preview/:id"
              element={<AutomationPreview {...param} />}
            />
            <Route
              path="/setting/automation/:id"
              element={<AutomationUpdate {...param} />}
            />
            <Route
              path="/setting/automation"
              element={<AutomationList {...param} />}
            />

            <Route
              path="/setting/auto_report"
              element={<AutoReportList {...param} />}
            />

            <Route
              path="/setting/custom-reminder/:id"
              element={<CustomReminderUpdate {...param} />}
            />
            <Route
              path="/setting/custom-reminder"
              element={<CustomReminderList {...param} />}
            />

            <Route
              path="/setting/third-party/*"
              element={<ThirdPartyRoute {...param} />}
            />
            <Route
              path="/setting/third-party/ai-integration"
              element={<AiIntegrationList />} />
            <Route 
              path="/setting/third-party/ai-integration/add-edit/:id"
              element={<AddAiIntegration />} />
            <Route
              path="/setting/third-party/api-log/:id"
              element={<ApiLogList />}
            />

            <Route
              path="/setting/billing"
              element={<BillingList {...param} />}
            />

            <Route
              path="/setting/role/:innerId/module/field/:modelId"
              element={
                <ModuleFieldList
                  {...param}
                  context={DefaultControllerConst.Inner}
                />
              }
            />
            <Route
              path="/setting/role/:innerId/module"
              element={
                <ModuleList {...param} context={DefaultControllerConst.Inner} />
              }
            />
            <Route
              path="/setting/role/add-edit/:roleId"
              element={<RoleUpdate {...param} />}
            />
            <Route path="/setting/role" element={<RoleList {...param} />} />

            {/*
            <Route path='/setting/dashboard/add-edit/:id' element={<DashboardUpdate {...param} />} />
            <Route path='/setting/dashboard/preview/:id' element={<DashboardPreview {...param} />} />
            <Route path='/setting/dashboard/demo/:id' element={<DashboardDemo {...param} />} />
            */}

            <Route
              path="/setting/dashboard/dashlead/add-edit/:id"
              element={<DashleadUpdate {...param} />}
            />
            <Route
              path="/setting/dashboard/dashlead"
              element={<DashleadList {...param} />}
            />
            <Route
              path="/setting/dashboard"
              element={<DashboardList {...param} />}
            />

            <Route
              path="/setting/user/email-edit/:userId"
              element={<UserMailUpdate {...param} />}
            />
            <Route
              path="/setting/user/add-edit/:userId"
              element={<UserUpdate {...param} />}
            />
            <Route
              path="/setting/user/preview/:userId"
              element={<UserPreview {...param} />}
            />
            <Route path="/setting/user" element={<UserList {...param} />} />

            <Route
              path="/setting/module/field/conditional/:fieldId"
              element={<ConditionalField {...param} />}
            />
            <Route
              path="/setting/module/field/options/:fieldId"
              element={<OptionList {...param} />}
            />
            <Route
              path="/setting/module/field/:modelId"
              element={
                <FieldList {...param} context={DefaultControllerConst.Global} />
              }
            />
            <Route
              path="/setting/module"
              element={
                <ModuleList
                  {...param}
                  context={DefaultControllerConst.Global}
                />
              }
            />

            <Route
              path="/setting/product/measure-unit"
              element={<UnitMeasureList {...param} />}
            />
            <Route
              path="/setting/product/category"
              element={<CategoryList {...param} />}
            />
            <Route
              path="/setting/product/import"
              element={<ProductImport {...param} />}
            />
            <Route
              path="/setting/product"
              element={<ProductList {...param} />}
            />

            <Route
              path="/setting/probability"
              element={<ProbabilityList {...param} />}
            />

            <Route
              path="/setting/document_type"
              element={<DocumentTypeList {...param} />}
            />

            <Route
              path="/setting/installment_mode"
              element={<InsallmentModeList {...param} />}
            />

            <Route path="/setting/source" element={<SourceList {...param} />} />

            <Route
              path="/setting/property-project/add-edit/:id"
              element={<PropertyProjectTemplateUpdate {...param} />}
            />
            <Route
              path="/setting/property-project"
              element={<PropertyProjectTemplateList {...param} />}
            />

            <Route
              path="/setting/email-template/mass-email"
              element={<EmailConfig {...param} />}
            />
            <Route
              path="/setting/email-template/add-edit/:id"
              element={<EmailTemplateUpdate {...param} />}
            />
            <Route
              path="/setting/email-template"
              element={<EmailTemplateList {...param} />}
            />

            <Route
              path="/setting/email-configuration/add-edit/:emailConfigId"
              element={<EmailConfigurationUpdate {...param} />}
            />
            <Route
              path="/setting/email-configuration"
              element={<EmailConfigurationList {...param} />}
            />

            <Route
              path="/setting/sms-configuration/add-edit/:smsConfigId"
              element={<SmsConfigurationUpdate {...param} />}
            />
            <Route
              path="/setting/sms-configuration"
              element={<SmsConfigurationList {...param} />}
            />

            <Route
              path="/setting/sms-template"
              element={<SmsTemplateList {...param} />}
            />
            <Route
              path="/setting/whatsapp-template"
              element={<WhatsAppTemplateList {...param} />}
            />

            <Route
              path="/setting/import/add"
              element={<LeadImport {...param} />}
            />
            <Route
              path="/setting/import/view/:csv/:res"
              element={<ImportDetails {...param} />}
            />
            <Route path="/setting/import" element={<ImportList {...param} />} />

            <Route path="/setting/export" element={<ExportList {...param} />} />

            <Route
              path="/setting/mass-mail/preview/:id"
              element={<MassMailPrev {...param} />}
            />
            <Route
              path="/setting/mass-mail"
              element={<MassMailList {...param} />}
            />

            <Route
              path="/setting/mass-sms/preview/:id"
              element={<MassSmsPrev {...param} />}
            />
            <Route
              path="/setting/mass-sms"
              element={<MassSmsList {...param} />}
            />

            <Route
              path="/setting/mass-whatsapp/preview/:id"
              element={<MassWhatsAppPrev {...param} />}
            />
            <Route
              path="/setting/mass-whatsapp"
              element={<MassWhatsAppList {...param} />}
            />

            <Route path="/setting/area" element={<AreaList {...param} />} />
            <Route
              path="/setting/campaign"
              element={<CampaignList {...param} />}
            />

            <Route
              path="/setting/view/:id"
              element={<ViewUpdate {...param} />}
            />
            <Route path="/setting/view" element={<ViewList {...param} />} />
            <Route path="/setting/kanban" element={<KanbanList {...param} />} />
            <Route
              path="/setting/kanban/:id"
              element={<KanbanUpdate {...param} />}
            />

            <Route path="/setting" element={<Settings {...param} />} />

            <Route
              path="/lead/next-prev/:indx"
              element={<LeadNextPrev {...param} />}
            />
            <Route
              path="/lead/add-edit/:id"
              element={<ModelAddUpdate {...param} model_no="1" />}
            />
            <Route
                path="/lead/preview/:leadId"
                element={
                  LeadTheme === LeadConst.CompactView ? (
                    <LeadPrevNew {...param} />
                  ) : LeadTheme === LeadConst.ModernView && this.isGrowthPackageAndAbove ? (
                    <LeadPrevDesign4 {...param} />
                  ) : (
                    <LeadPreview {...param} />
                  )
                }
              />

            <Route
              path="/lead/history/:leadId"
              element={<LeadHistory {...param} />}
            />
            <Route
              path="/lead/duplicate"
              element={<DuplicateLeadList {...param} />}
            />
            <Route path="/lead" element={<LeadList {...param} />} />

            <Route
              element={<LeadScoreList {...param} />}
              path="/setting/lead_score"
            />

            <Route
              path="/setting/lead_score/:id"
              element={<LeadScoreAddUpdate {...param} />}
            />

            <Route
              path="/setting/lead_score/preview/:id"
              element={<LeadScorePreview {...param} />}
            />

            <Route
              path="/contact/add-edit/:contactId/:moduleNo/:modelId"
              element={<ContactUpdate {...param} />}
            />
            <Route
              path="/contact/add-edit/:contactId"
              element={<ContactUpdate {...param} />}
            />
            <Route
              path="/contact/preview/:contactId"
              element={<ContactPreview {...param} />}
            />
            <Route path="/contact" element={<ContactList {...param} />} />

            <Route
              path="/customer/add-edit/:customerId"
              element={<CustomerUpdate {...param} />}
            />
            <Route
              path="/customer/preview/:customerId"
              element={<CustomerPreview {...param} />}
            />
            <Route path="/customer" element={<CustomerList {...param} />} />

            <Route path="/call" element={<CallList {...param} />} />
            <Route path="/meeting" element={<MeetingList {...param} />} />

            <Route
              path="/sales-order/add-edit/:modelNo/:modelId/:saleId"
              element={<SalesOrderUpdate {...param} />}
            />
            <Route
              path="/sales-order/preview/:id"
              element={<BookingPreviewWrapper {...param} />}
            />
            <Route
              path="/sales-order"
              element={<SalesOrderList {...param} />}
            />

            <Route
              path="/installment"
              element={<InstallmentList {...param} />}
            />

            <Route
              path="/property/add-edit/:propertyId"
              element={<PropertyUpdate {...param} />}
            />
            <Route
              path="/property/preview/:propertyId"
              element={<PropertyPreview {...param} />}
            />
            <Route path="/property" element={<PropertyList {...param} />} />

            <Route
              path="/project/add-edit/:projectId"
              element={<ProjectUpdate {...param} />}
            />
            <Route
              path="/project/preview/:projectId"
              element={<ProjectPreview {...param} />}
            />
            <Route path="/project" element={<ProjectList {...param} />} />
            <Route
              path="/tower/preview/mass-update/:towerId"
              element={<TowerRoomUpdate {...param} />}
            />
            <Route
              path="/tower/preview/:towerId"
              element={<TowerPreview {...param} />}
            />

            <Route
              path="/floor-rise/preview/:towerId"
              element={<FloorRisePreview {...param} />}
            />

            <Route
              path="/attendance/add-edit/:id"
              element={<AttendanceUpdate {...param} />}
            />
            <Route path="/attendance" element={<AttendanceList {...param} />} />

            <Route path='/live-location-tracking' element={<LocationTracker {...param} />} />

            <Route path="/sms-list" element={<SmsList {...param} />} />
            <Route path="/sms-add`" element={<SmsAdd {...param} />} />

            <Route path="/search" element={<SearchTable {...param} />} />

            <Route path="/calendar" element={<BigCalendar {...param} />} />

            <Route
              path="/notifications"
              element={<Notifications {...param} />}
            />

            <Route path="/dashboard" element={<Dashboard {...param} />} />

            <Route path="/note" element={<NoteList {...param} />} />

            <Route path="/" element={<Dashboard {...param} />} />
          </Routes>
          <Footer user={this.user} />
        </ApiUiController>
      </div>
    );
  }
}
export default withRouter(DefaultController);
